import { get } from "foundation/js/api"
import { defineStore } from "pinia"

export const useSearchStore = defineStore("search", {
    state: () => ({
        filters: {},
        tags: {},
        searchUrls: {},
        results: {},
        totalHits: {},
        searchQuery: {},
        currentPage: {},
        takeSize: {},
        loading: false
    }),
    getters: {},
    actions: {
        setFilters(payload) {
            this.filters[payload.searchKey] = payload.filters
        },
        setFilterOpenState(payload) {
            if (payload.name) {
                this.filters[payload.searchKey].forEach((filter) => {
                    if (filter.name === payload.name) {
                        filter.open = payload.open
                    }
                })
            } else {
                this.filters[payload.searchKey].forEach((filter) => {
                    filter.open = payload.open
                })
            }
        },
        setTags(payload) {
            if (!this.tags[payload.searchKey]) {
                this.tags[payload.searchKey] = [payload.tag]
            } else {
                if (!this.tags[payload.searchKey].find((tag) => tag.value === payload.tag.value)) {
                    this.tags[payload.searchKey].push(payload.tag)
                }
            }
            this.performSearch({ searchKey: payload.searchKey, replaceResults: true })
            this.setCurrentPage({ searchKey: payload.searchKey, resetPage: true })
        },
        setSearchUrl(payload) {
            this.searchUrls[payload.searchKey] = payload.url
        },
        setResults(payload) {
            this.results[payload.searchKey] = payload.results
        },
        setSearchQuery(payload) {
            this.searchQuery[payload.searchKey] = payload.query
            let url = new URL(window.location);
            url.searchParams.set('q', payload.query);
            window.history.pushState({}, '', url);
        },
        setTakeSize(payload) {
            this.takeSize[payload.searchKey] = payload.take
        },
        setCurrentPage(payload) {
            if (this.currentPage[payload.searchKey]) {
                this.currentPage[payload.searchKey] = this.currentPage[payload.searchKey] + 1
            } else {
                this.currentPage[payload.searchKey] = 1
            }

            if (payload.resetPage) {
                this.currentPage[payload.searchKey] = 1
            }
        },
        removeTag(payload) {
            this.tags[payload.searchKey] = this.tags[payload.searchKey].filter((tag) => tag.value !== payload.tagValue)
            this.performSearch({ searchKey: payload.searchKey, replaceResults: true })
            this.setCurrentPage({ searchKey: payload.searchKey, resetPage: true })
        },
        constructUrl(payload) {
            const languageCode = (document.documentElement.lang || 'en').substring(0, 2); // Default to 'en' if not found and take the first two characters

            let url = `${document.location.origin}/${this.searchUrls[payload.searchKey]}`.replace("[lang]", languageCode)
           
            const skip = (this.currentPage[payload.searchKey] - 1) * this.takeSize[payload.searchKey] 
            url = `${url}${getSymbol(url)}skip=${skip}`
            url = `${url}${getSymbol(url)}take=${this.takeSize[payload.searchKey]}`
           
           if (payload.take) {
           }
           if (this.searchQuery[payload.searchKey]) {
                url = `${url}${getSymbol(url)}q=${this.searchQuery[payload.searchKey]}`
           }
           if (this.tags[payload.searchKey] && this.tags[payload.searchKey].length > 0) {
                const params = this.tags[payload.searchKey].map((tag) => tag.value).join(",")
                url = `${url}${getSymbol(url)}tags=${params}`
           }
           return url
        },
        async performSearch(payload) {
            this.loading = true
            const url = this.constructUrl(payload)

            // get the search results
            const response = await get(url)
            // payload options do empty search
            if (response?.hits) {
                if (payload.replaceResults) {
                    this.results[payload.searchKey] = response.hits
                } else {
                    this.results[payload.searchKey] = 
                        this.results[payload.searchKey] 
                        ? this.results[payload.searchKey].concat(response.hits) 
                        : response.hits
                }
            }
            // if (response?.facets) {
            //     this.filters[payload.searchKey] = response.facets
            // }
            if (response?.totalHits !== undefined) {
                this.totalHits[payload.searchKey] = response.totalHits
            }

            this.loading = false
        },
        async getMoreResults(payload) {
            this.setCurrentPage({ searchKey: payload.searchKey })
            this.performSearch({ guid: payload.guid, searchKey: payload.searchKey, replaceResults: payload.replaceResults })
        }
    }
})

const getSymbol = function(url) {
    return url.includes('?') ? '&' : '?'
}